import { FieldValues, useController, UseControllerProps } from 'react-hook-form'
import { Textarea } from '../../shadcn/textarea'

export type ControlledTextareaProps<T extends FieldValues> = UseControllerProps<T> &
  Partial<React.ComponentProps<'textarea'>> & {
    className?: string
    label?: string
    inputClassName?: string
  }

export function ControlledTextarea<T extends FieldValues>({
  control,
  name,
  rules,
  defaultValue,
  className,
  label,
  inputClassName,
  ...rest
}: ControlledTextareaProps<T>) {
  const { field, fieldState } = useController({
    control,
    name,
    rules,
    defaultValue,
  })

  return (
    <div className={className}>
      <label className={label === undefined ? 'none' : ''}>{label}</label>
      <Textarea {...rest} onChange={field.onChange} value={field.value} className={inputClassName} />
      {!!fieldState.error?.message && <span className={'text-red-500'}>{fieldState.error?.message}</span>}
    </div>
  )
}
